import { useMemo } from 'react'
import { resolveClearSigning, type ClearSigningResult } from '../erc7730/resolve.js'

/**
 * Resolves calldata against safeward's vendored ERC-7730 descriptors. Resolution
 * is synchronous (descriptors are bundled, not fetched), but this mirrors
 * useDecoded4byte.ts's `(input) => T | null` shape so call sites stay stable if
 * resolution ever needs to become async.
 */
export function useClearSigning(
  to: string | undefined,
  data: string | undefined,
  value?: string,
): ClearSigningResult | null {
  return useMemo(() => resolveClearSigning(to, data, { value }), [to, data, value])
}
